import {
  getDefaultSingleSelections,
  getProductCategoryTypes,
} from './productDetail';
import { getBraSizes, getShoeSizes, getSortedRegularSizes } from './sizes';

export function getModelSizeIndex(modelSize, product, tld) {
  const { isSlippers, isBra } = getProductCategoryTypes(
    product.productCategoryIdList || product.product_category_id_list,
    product.tagIdList || product.tag_id_list
  );

  const sizeList = (() => {
    if (isSlippers) {
      return getShoeSizes(tld).map(({ label }) => label);
    }

    if (isBra) {
      const braList = getBraSizes(tld);
      return [...braList.regular, ...braList.plus].map(({ label }) => label);
    }

    return getSortedRegularSizes(tld);
  })();

  const sizeIndex = sizeList.findIndex(size => size === modelSize);

  // We'll set it to the list's length so that unfound sizes will be placed to the last
  return {
    sizeIndex: sizeIndex > -1 ? sizeIndex : sizeList.length,
  };
}

export function getSelectedSize(product = {}, customer, isSoldOut) {
  const sizeCache =
    typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem('selectedSize'))
      : {};

  return getDefaultSingleSelections(product, customer, isSoldOut, sizeCache)
    .size;
}

export function getClosestModelBySize(
  models = [],
  selectedSizeIndex,
  defaultModel
) {
  if (!models.length && !Number.isInteger(selectedSizeIndex)) {
    return defaultModel;
  }

  return models.reduce(
    (prevModel, model) =>
      (model.canBeDefault || model.canBeDefault === undefined) &&
      Math.abs(model.sizeIndex - selectedSizeIndex) <
        Math.abs(prevModel.sizeIndex - selectedSizeIndex)
        ? model
        : prevModel,
    models[0]
  );
}
